import { withClassName } from 'Modules/ui';

import styles from './index.module.scss';


export const TwoColumnLayout = withClassName(styles.twoColumnLayout, 'div');
